import FilesDetails from "./FilesDetails";

export default FilesDetails;
